import { useTranslation } from 'react-i18next';
import { ReactComponent as KioskSearchIcon } from '../../../assets/icons/KioskSearchIcon.svg';
import { KioskEmptyIconCircle, KioskEmptyTitle, KioskEmptyWrap } from '../styles';

interface KioskEmptyStateProps {
  messageKey: string;
}

/** Centered empty state — used for both "no employees" and "no search match". */
const KioskEmptyState = ({ messageKey }: KioskEmptyStateProps) => {
  const [t] = useTranslation();
  return (
    <KioskEmptyWrap>
      <KioskEmptyIconCircle>
        <KioskSearchIcon width={52} height={52} />
      </KioskEmptyIconCircle>
      <KioskEmptyTitle>{t(messageKey)}</KioskEmptyTitle>
    </KioskEmptyWrap>
  );
};

export default KioskEmptyState;
